import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';
import { RaisedButton, LinearProgress } from 'material-ui';
import { getConfigValue } from '../../reducers/configReducer';
import { connect } from 'react-redux';
import { secondaryColor, CURRENT_ACH_PROVIDER } from '../../config/const';
import { DARK_GREY, ACCENT_COLOR, WHITE } from '../../config/colors';
import { ItemsIcon } from '../../icons';
import * as modal from '../../reducers/modalReducer';
import { AEROPAY } from '../../const/ach_const';
import { 
  abandonDraftTicket, cancelTicketAndPayment, processDraftTicket, 
  resetCheckout, saveDraftTicket, generateMsoAchPaymentLink } from '../../actions/ticket';
import { placeOrderReset } from '../../reducers/checkoutReducer';
import { failureUri, thankYouUri } from '../../config/uri';
import { pushWithQueryParams } from '../../services/uri';
import { getTicketDetails } from '../../services/tickets';


const TIME_BEFORE_START_POLLING = 30000; //30 secs
const TIME_BETWEEN_POLLS_MSO = 5000; //5 secs
const AUTHORIZED = 'AUTHORIZED';

class MsoAchPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticketId: null,
      isPayingInProgress: false,
      isOrderProcessInProgress: false,
      timerPolling: null,
      timerTabCheck: null,
      paymentTab: null,
    };
  }

  secondaryColor = `#${this.props.secondaryColor}`;

  componentDidMount() {
  }

  componentWillUnmount() {
    this.clearTimeouts();
    this.closePaymentTab();
  }

  closePaymentTab() {
    if (this.state.paymentTab) {
      this.state.paymentTab.close();
    }
  }

  clearTimeouts() {
    if(this.state.timerPolling){
      clearTimeout(this.state.timerPolling);
    }
    if(this.state.timerTabCheck){
      clearTimeout(this.state.timerTabCheck);
    }
  }

  clearAndSetTimeout(name, timerId) {
    if(this.state[name]){
      clearTimeout(this.state[name]);
    }
    this.setState({[name]: timerId});
  }

  renderProgress = () => {
    return (
      <div className="ach-payment">
        <div className="text-center"><h4>Loading...</h4></div>
        <LinearProgress color={ACCENT_COLOR} mode="indeterminate" />
      </div>
    )
  }

  isIframeFlow = () => {
    return !(this.props.currentAchProvider === AEROPAY);
  }

  verifyTicket = async (ticketId) => {

    if(!this.state.isPayingInProgress) return;

    getTicketDetails(ticketId)
    .then(({data: result}) => {
      this.setState({isPayingInProgress: false});
      if(result.ticket.paymentStatus === AUTHORIZED) {
        this.completeOrder(ticketId);
      } else {
        this.showFailurePage();
        this.props.abandonDraftTicket(ticketId);
      }
    })
    .catch((error) => {
      console.error(error);
      this.setState({isPayingInProgress: false});
    });
  }

  ticketStatusPolling = (ticketId) => {
    if(!this.state.isPayingInProgress || this.state.isOrderProcessInProgress) {
      return;
    }
    console.info("Polling Mechanism...");

    getTicketDetails(ticketId)
    .then(({data: result}) => {
      if(result.ticket.paymentStatus === AUTHORIZED) {
        if(this.isIframeFlow()) {
          this.props.hideModal();
        } else {
          this.closePaymentTab();
        } 
        this.completeOrder(ticketId);
      } else {
        const timerPolling = setTimeout(() => {
          this.ticketStatusPolling(ticketId);
        }, TIME_BETWEEN_POLLS_MSO);
        this.clearAndSetTimeout("timerPolling", timerPolling);
      }
    })
    .catch((error) => {
      console.error(error);
    });
  }

  paymentTabCheck = (paymentTab, ticketId) => {
    if(!paymentTab){ return; }
    if(paymentTab.closed) {
      this.verifyTicket(ticketId);
      return;
    }
    console.info("Payment tab checking...");
    const timerTabCheck = setTimeout(() => {
      this.paymentTabCheck(paymentTab, ticketId);
    }, TIME_BETWEEN_POLLS_MSO);
    this.clearAndSetTimeout("timerTabCheck", timerTabCheck);
  }

  completeOrder = async (ticketId) =>  {
    if(this.state.isOrderProcessInProgress) return;

    this.setState({isOrderProcessInProgress: true});
    this.props.processDraftTicket(ticketId, "msotreezpay")
    .then(() => {
      this.showSuccessPage();
    })
    .catch((error) => {
      console.error(error);
      this.props.cancelTicketAndPayment(ticketId, "msotreezpay");
      this.showFailurePage();
    });
  }

  payNow = () => {
    const { rewardDollars, notes } = this.props;
    const { isPayingInProgress } = this.state;
    
    if (isPayingInProgress) return;

    this.setState({isPayingInProgress: true});

    this.props.saveDraftTicket({ rewardDollars, notes })
      .then(({ data: ticketResult }) => {
        const isSuccess = ticketResult.resultCode === 'SUCCESS';

        if (!isSuccess) return;

        const ticketId = ticketResult.orderId;

        this.setState({ticketId: ticketId});
        this.props.generateMsoAchPaymentLink(ticketId)
          .then(({data: result}) => {

            if(this.isIframeFlow()) {
              this.props.openMsoPaymentIframeModal({
                hideModal: () => {
                  this.props.hideModal();
                  this.verifyTicket(ticketId);
                },
                paymentUrl: result.data.url,
              });
            } else {
              this.closePaymentTab();
              const paymentTab = window.open(result.data.url, '_blank');
              this.setState({paymentTab: paymentTab});
              const timerTabCheck = setTimeout(() => {
                console.info("PaymentTab check...");
                this.paymentTabCheck(paymentTab, ticketId);
              }, TIME_BETWEEN_POLLS_MSO);
              this.clearAndSetTimeout("timerTabCheck", timerTabCheck);
            } 

            const timerPolling = setTimeout(() => {
              console.info("Timeout detected, switching to Polling Mechanism...");
              this.ticketStatusPolling(ticketId);
            }, TIME_BEFORE_START_POLLING);
            this.clearAndSetTimeout("timerPolling", timerPolling);

          })
          .catch((error) => {
            console.error(error);
            this.setState({isPayingInProgress: false});
            this.props.abandonDraftTicket(ticketId);
            this.showFailurePage();
          });
      })
      .catch((error) => {
        console.error(error);
        this.setState({isPayingInProgress: false});
        this.showFailurePage();
      });
  }

  showSuccessPage = () => {
    this.props.resetCheckout();
    this.props.placeOrderReset();
    this.props.push(thankYouUri);
  }

  showFailurePage = () => {
    this.props.push(failureUri);
  }

  renderSummary = () => {
    const { ticketTotals } = this.props;

    if (!ticketTotals) return null;

    const subTotalFinal = ticketTotals.adjustedSubtotal.formatMoney();
    const tierDiscountTotal = ticketTotals.tierDiscountTotal.formatMoney();
    const taxTotalFinal = ticketTotals && ticketTotals.taxTotal ? ticketTotals.taxTotal.formatMoney() : '$0.00';
    const totalFinal = ticketTotals.total.formatMoney();

    return (
      <div className="ach-payment-summary-container">
        <div className="ach-payment-summary-icon">
          <ItemsIcon color={DARK_GREY} />
        </div>

        <div className="ach-payment-summary">
          <div className="ach-payment-summary-row">
            <label>SUB TOTAL: </label>
            <label className="text-bold">{subTotalFinal}</label>
          </div>
          <div className="ach-payment-summary-row">
            <label>TIER DISCOUNT: </label>
            <label className="text-bold">{tierDiscountTotal}</label>
          </div>
          <div className="ach-payment-summary-row">
            <label>TAX: </label>
            <label className="text-bold">{taxTotalFinal}</label>
          </div>
          <div className="ach-payment-summary-row">
            <label className="text-bold">TOTAL: </label>
            <label className="text-bold">{totalFinal}</label>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isPayingInProgress, isOrderProcessInProgress } = this.state;

    if (isPayingInProgress || isOrderProcessInProgress) {
      return this.renderProgress();
    }

    return (
      <div className="ach-payment">
        

        <hr className="ach-payment-splitter" />

        <h4 className="ach-payment-section-title">PAYMENT:</h4>

        <hr className="ach-payment-splitter" />

        {this.renderSummary()}
        
        <hr className="ach-payment-splitter" />

        <div className="ach-payment-select-account">

          <RaisedButton
              backgroundColor={this.secondaryColor}
              labelColor={WHITE}
              label="PAY NOW"
              labelStyle={{ fontWeight: 700 }}
              style={{ minWidth: '335px', margin: '0 auto'}}
              onClick={this.payNow}
            />
        </div>
      </div>
    );
  }
}

MsoAchPayment.propTypes = {
  items: PropTypes.array.isRequired,
  summary: PropTypes.object.isRequired,
  ticketLines: PropTypes.object.isRequired,
  ticketTotals: PropTypes.object,
  ticketItems: PropTypes.array.isRequired,
  notes: PropTypes.string.isRequired,
  handleCheckout: PropTypes.func.isRequired,
  closeAchPayment: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  secondaryColor: getConfigValue(secondaryColor, state),
  currentAchProvider: getConfigValue(CURRENT_ACH_PROVIDER, state),
});

const mapDispatchToProps = dispatch => ({
  saveDraftTicket: data => dispatch(saveDraftTicket(data)),
  abandonDraftTicket: ticketId => dispatch(abandonDraftTicket(ticketId)), 
  cancelTicketAndPayment: (ticketId, chargeId) => dispatch(cancelTicketAndPayment(ticketId, chargeId)),
  processDraftTicket: (ticketId, chargeId) => dispatch(processDraftTicket(ticketId, chargeId)),
  generateMsoAchPaymentLink: (ticketId) => dispatch(generateMsoAchPaymentLink(ticketId)),
  placeOrderReset: () => dispatch(placeOrderReset()),
  hideModal: () => dispatch(modal.hideModal()),
  push: (url) => dispatch(pushWithQueryParams(url)),
  openMsoPaymentIframeModal: props => dispatch(modal.openModal({
    modalType: 'MSO_PAY_IFRAME_MODAL',
    modalProps: props
  })),
  resetCheckout: () => dispatch(resetCheckout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MsoAchPayment);



// WEBPACK FOOTER //
// ./src/components/MsoAchPayment/MsoAchPayment.jsx